import { useRouter } from '@/domains/shared/router/Router';
import { Button } from '@/domains/shared/components/Button';
import { Card, CardTitle, CardContent } from '@/domains/shared/components/Card';
export function InstructionsPage() {
  const { navigate } = useRouter();

  return (
    <div className="flex min-h-screen flex-col bg-navy text-brand-offWhite">
      {/* Header com botão de voltar */}
      <header className="border-b border-white/10 bg-navy-dark/90 px-4 py-3.5 sm:px-6">
        <div className="mx-auto flex max-w-2xl items-center justify-between">
          <button
            type="button"
            onClick={() => navigate('/')}
            className="inline-flex items-center gap-1.5 text-xs font-semibold text-brand-offWhite/80 hover:text-white transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-orange rounded p-1"
          >
            <span>←</span> Voltar ao início
          </button>
          <span className="text-xs font-medium text-brand-orange">Orientações</span>
        </div>
      </header>

      <main className="mx-auto flex w-full max-w-2xl flex-1 flex-col justify-center px-4 py-10 sm:py-14">
        <div className="text-left">
          <span className="text-xs font-bold uppercase tracking-wider text-brand-orange">
            Instruções Rápidas
          </span>
          <h1 className="mt-2 text-2xl font-black text-white sm:text-3xl">
            Como funciona o Diagnóstico
          </h1>
          <p className="mt-2 text-sm text-brand-offWhite/80">
            Responda pensando na rotina prática do seu escritório contábil hoje, com honestidade. O objetivo é clareza estratégica, não uma nota perfeita.
          </p>
        </div>

        {/* Como responder a escala */}
        <div className="mt-8 space-y-4 text-left">
          <h2 className="text-sm font-bold uppercase tracking-wider text-white">
            Cada pergunta possui 4 níveis de maturidade (0 a 3 pontos):
          </h2>

          <div className="space-y-2.5">
            <div className="flex items-center gap-3.5 rounded-xl border border-white/10 bg-navy-light/40 p-3.5">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-brand-orange/20 text-xs font-black text-brand-orange">
                0
              </span>
              <span className="text-sm font-medium text-white">Inicial / Não implementado ou inexistente</span>
            </div>
            <div className="flex items-center gap-3.5 rounded-xl border border-white/10 bg-navy-light/40 p-3.5">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-brand-orange/20 text-xs font-black text-brand-orange">
                1
              </span>
              <span className="text-sm font-medium text-white">Pontual / Ações esporádicas ou sem processo</span>
            </div>
            <div className="flex items-center gap-3.5 rounded-xl border border-white/10 bg-navy-light/40 p-3.5">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-brand-orange/20 text-xs font-black text-brand-orange">
                2
              </span>
              <span className="text-sm font-medium text-white">Em consolidação / Estruturado, mas ainda com gargalos</span>
            </div>
            <div className="flex items-center gap-3.5 rounded-xl border border-white/10 bg-navy-light/40 p-3.5">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-brand-orange/20 text-xs font-black text-brand-orange">
                3
              </span>
              <span className="text-sm font-medium text-white">Consistente / Método claro, rotina ativa e mensurada</span>
            </div>
          </div>

          <p className="text-xs text-brand-offWhite/60 italic">
            * Cada pergunta apresentará 4 alternativas específicas e contextualizadas para você selecionar a que melhor descreve seu momento.
          </p>
        </div>

        {/* Informações adicionais */}
        <Card className="mt-8 p-4 bg-white/5 border-white/10 text-left">
          <CardTitle className="text-sm font-bold text-white flex items-center gap-2">
            <svg className="h-4 w-4 text-brand-orange" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
            </svg>
            Importante saber antes de começar:
          </CardTitle>
          <CardContent className="mt-2 space-y-1.5 text-xs text-brand-offWhite/80">
            <p>• São exatamente 18 perguntas (uma por tela).</p>
            <p>• Leva em média de 3 a 5 minutos.</p>
            <p>• Suas respostas ficam salvas durante a navegação.</p>
            <p>• Ao final, você recebe a nota geral e o radar das 6 dimensões.</p>
          </CardContent>
        </Card>

        {/* Botão para iniciar */}
        <div className="mt-8 flex flex-col gap-3">
          <Button
            variant="primary"
            size="lg"
            onClick={() => navigate('/diagnostico')}
            className="w-full text-base font-bold shadow-lg shadow-brand-orange/20"
          >
            Bora começar →
          </Button>
        </div>
      </main>
    </div>
  );
}
